import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HtmlStringifyPipe } from './html-stringify.pipe';
import { MapsPipe } from './maps.pipe';
import { PluckPipe } from './pluck.pipe';
import { TranslatePipe } from './protocol-droid.pipe';
import { RemoveHtmlPipe } from './remove-html.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SimpleTextPipe } from './simple-text.pipe';
import { SortPipe } from './sort.pipe';
import { SpaceNumbersPipe } from './space-numbers.pipe';
import { TrustRessourcePipe } from './trust-ressource.pipe';
import { TrustUrlPipe } from './trust-url.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    MapsPipe,
    TrustRessourcePipe,
    TrustUrlPipe,
    SimpleTextPipe,
    HtmlStringifyPipe,
    SpaceNumbersPipe,
    SortPipe,
    PluckPipe,
    TranslatePipe,
    SafeHtmlPipe,
    RemoveHtmlPipe
  ],
  exports: [
    MapsPipe,
    TrustRessourcePipe,
    TrustUrlPipe,
    SimpleTextPipe,
    HtmlStringifyPipe,
    SpaceNumbersPipe,
    SortPipe,
    PluckPipe,
    TranslatePipe,
    SafeHtmlPipe,
    RemoveHtmlPipe
  ]
})
export class PipesModule {}
